<template>
  <div class="warp">
    <div class="boxc">
      <div class="boxcs" v-if="mima == 1">
        <div class="choice">
          <div class="choiceLeft" style="margin-right: 30px">
            <div class="choiceLeftText">重置密码</div>
          </div>
        </div>

        <div class="boxcsCent">
          <div class="boxcsCents">
            <span class="add86 colf2 shrink0">+86</span>
            <el-input v-model.trim="zhphone" placeholder="请输入手机号" style="width: 320px" @input="zhphoneVerify" />
          </div>
          <div class="boxcsCents">
            <el-input v-model.trim="zhimgCode" placeholder="请输入验证码" style="width: 210px" @input="zhimgCodeVerify" />
            <div style="border: 1px solid #000000">
              <img :src="codeImg" alt="验证码" style="width: 100%; height: 100%" @click="refresh" />
            </div>
          </div>
          <div class="confirmBtn">
            <el-button :style="forgotBtnStatus ? 'background: #CCCCCC' : 'background: #FF5E51'
              " :disabled="forgotBtnStatus" class="boxcsCentss" @click="imgb">确定</el-button>
          </div>
          <span @click="toLogin" class="toLogin">返回登录</span>
        </div>
      </div>
      <div class="boxcs" v-if="mima == 2">
        <div class="choice">
          <div class="choiceLeft" style="margin-right: 30px">
            <div class="choiceLeftText">重置密码</div>
          </div>
        </div>

        <div class="boxcsCent">
          <div class="confirmPhone">
            <p>已验证手机：</p>
            <span>{{ zhphone }}</span>
          </div>
          <div class="boxcsCents">
            <el-input style="width: 100%" v-model="zhshortCode" type="text" placeholder="请输入验证码">
              <el-button style="background: #f2f2f2" v-if="!disable" slot="suffix" class="inp_yzm" type="text"
                @click="loginSmsCode">点击获取验证码
              </el-button>
              <el-button style="background: #f2f2f2" v-if="disable" slot="suffix" class="inp_yzm" type="text">{{ title
                }}
              </el-button>
            </el-input>
          </div>
          <div class="confirmBtnSecond">
            <div :style="false ? 'background: #CCCCCC' : 'background: #FF5E51'" class="boxcsCentss" @click="imgc">
              确定
            </div>
          </div>
        </div>
      </div>
      <div class="boxcs" v-if="mima == 3">
        <div class="choice">
          <div class="choiceLeft" style="margin-right: 30px">
            <div class="choiceLeftText">重置密码</div>
          </div>
        </div>
        <div class="boxcsCent">
          <div class="boxcsCents">
            <el-input v-model.trim="zhpassword" placeholder="请输入新密码" show-password style="width: 100%" />
          </div>
          <div class="boxcsCents">
            <el-input v-model.trim="zhpasswords" placeholder="请再次确认新密码" show-password style="width: 100%" />
          </div>
          <div class="confirmBtnSecond">
            <div :style="false ? 'background: #CCCCCC' : 'background: #FF5E51'" class="boxcsCentss" @click="imgd">
              确定
            </div>
          </div>
        </div>
      </div>
      <div class="boxcs" v-if="mima == 4">
        <div class="choice">
          <div class="choiceLeft" style="margin-right: 30px">
            <div class="choiceLeftText">重置密码</div>
          </div>
        </div>
        <div class="boxcsCent">
          <div class="zhQueren">
            <img src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/Login/loginIcon862.png" />
            <p>找回密码成功</p>
          </div>
          <div class="confirmBtnSecond">
            <div :style="false ? 'background: #CCCCCC' : 'background: #FF5E51'" class="boxcsCentss" @click="goNext()">
              去登录
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog width="600px" :visible.sync="imgCodeDio">
      <imgCode @codeBack="codeBack" v-if="imgCodeDio"></imgCode>
    </el-dialog>
  </div>
</template>
<script>
// import { loginSmsCode } from "@/api/login";
// import { Zhpassword } from "@/api/zhpassword";
import { getDomain } from "@/api/cookies";
import imgCode from "@/views/login/imgCode.vue";
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
// import { SmsMobileCode } from "@/api/login";
import md5 from "js-md5";

// let zhpassword = new Zhpassword();
export default {
  components: { imgCode },
  data() {
    return {
      forgotBtnStatus: true,
      mima: 1,
      disable: false,
      title: "获取验证码",
      time: 0,
      welcomePotential: "confirmToken",
      zhphone: "",
      zhimgCode: "",
      zhimgCodes: "",
      zhshortCode: "",
      zhpassword: "",
      zhpasswords: "",
      domainInfo: {},
      imgCodeDio: false,
      captcha: "",
      codeImg: "",
      codeKey: ""
    };
  },
  created() {
    this.loadCaptcha();
  },
  mounted() {
    this.domainInfo = getDomain();

    setTimeout(() => {
      if (!!this.zhphone && !!this.zhimgCode) {
        this.forgotBtnStatus = false;
      }
    }, 1000);
  },
  methods: {
    zhimgCodeVerify() {
      if (!!this.zhphone && !!this.zhimgCode) {
        this.forgotBtnStatus = false;
      } else {
        this.forgotBtnStatus = true;
      }
    },
    zhphoneVerify() {
      if (!!this.zhphone && /^1\d{10}$/.test(this.zhphone) && !!this.zhimgCode) {
        this.forgotBtnStatus = false;
      } else {
        this.forgotBtnStatus = true;
      }
    },
    toLogin() {
      this.$emit("dealForgot");
    },
    refresh() {
      this.loadCaptcha();
    },
    goNext() {
      this.$emit("dealForgot");
    },
    loadCaptcha() {
      homeClient.getVerifyCode().then((res) => {
        this.codeImg = res.data.img
        this.codeKey = res.data.imgId
      })

    },
    async imgb() {
      if (this.zhphone == "") {
        this.$message.error("请输入手机号");
      } else if (!/^1\d{10}$/.test(this.zhphone)) {
        this.$message.error("请输入正确的手机号");
      } else if (this.zhimgCode == "") {
        this.$message.error("请输入验证码");
      } else {

        homeClient.checkVerification(this.zhimgCode, this.codeKey).then((res) => {
          if (res.code == 0) {
            homeClient.checkExistTel(this.zhphone).then((res) => {
              if (res.data) {
                this.mima = 2;
              } else {

                this.$message.error(res.msg);
                return;

              }
            });

          } else {
            this.zhimgCode = "";
            this.loadCaptcha();
            this.$message.error(res.msg);
          }
        });

      }
    },
    async loginSmsCode() {
      this.imgCodeDio = true;
    },
    async codeBack(val, vals) {
      this.imgCodeDio = false;
      this.domainInfo = getDomain();

      let me = this;

      if (this.time > 0) {
        return;
      }
      const secret = await homeClient.getSendSmsSecretKey();
      const localSecret = "jTwfQP7Q5iJHHsc2";
      const encryptedStr = md5(me.zhphone + vals + val + localSecret + secret.data);
      await homeClient.sendCodeJxy({
        phone: me.zhphone,
        imgId: vals,
        imgCode: val,
        encryptedStr: encryptedStr,

      }).then((res) => {
        if (res.code == 0) {
          me.time = 60;

          me.$message({
            message: "发送成功",
            type: "success",
          });

          me.disable = true;
          let interval = setInterval(() => {
            if (me.time < 1) {
              me.title = "重新发送";
              me.disable = false;
              clearInterval(interval);
            } else {
              me.title = me.time + "秒后重发";
              me.time--;
              me.disable = true;
            }
          }, 1000);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    imgc() {
      this.mima = 3;

    },
    imgd() {
      if (this.zhpassword.length < 6) {
        this.$message.error("密码长度不能少于6个字符");
        return;
      }
      if (this.zhpassword == this.zhpasswords) {
        homeClient
          .forgetPwd(this.zhphone, this.zhpassword, this.zhshortCode,)
          .then((res) => {
            if (res.code == 0) {
              this.mima = 4;
              // 保留DomainAuthorization和domain，清除其他所有内容
              const DomainAuthorization = localStorage.getItem('DomainAuthorization');
              const domain = localStorage.getItem('domain');
              localStorage.clear();
              if (DomainAuthorization) localStorage.setItem('DomainAuthorization', DomainAuthorization);
              if (domain) localStorage.setItem('domain', domain);
              this.$router.push("/");
            }
          });
      } else {
        this.$message.error("请输入相同的密码");
      }
    },
  },
};
</script>
<style lang="less" scoped>
.warp {
  width: 100%;

  .header {
    width: 100%;
    height: 36px;
    background: #f5f7fa;

    .headers {
      width: 65%;
      height: 100%;
      margin: auto;
      display: flex;
      justify-content: space-between;
      align-items: center;

      ul {
        width: auto;
        height: 100%;

        li {
          float: left;
          line-height: 36px;
          margin-right: 30px;
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          cursor: pointer;
        }
      }

      .headersRight {
        width: auto;
        height: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        cursor: pointer;
      }
    }
  }

  .boxc {
    width: 100%;
    background: #fff;
    overflow: hidden;

    .boxcs {
      margin: auto;
      background: #ffffff;
      overflow: hidden;
      position: relative;

      .boxcsCent {
        margin: auto;
        margin-top: 30px;

        .boxcsCents {
          width: 100%;
          height: 40px;
          margin-bottom: 24px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: #f2f2f2;

          div {
            width: 96px;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ff7f48;
            cursor: pointer;
          }

          button {
            outline: none;
            border: none;
            width: 96px;
            height: 40px;
            display: flex;
            margin-left: 14px;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ff7f48;
            cursor: pointer;
            background: #fff;
          }
        }

        .zhQueren {
          width: 180px;
          height: 122px;
          margin: auto;
          margin-bottom: 30px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          img {
            width: 40px;
            height: 40px;
          }

          p {
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #27323f;
          }
        }

        .boxcsCentss {
          width: 100%;
          height: 46px;
          border-radius: 8px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          cursor: pointer;
          border-radius: 8px;
        }
      }
    }
  }

  .diva {
    width: 96px;
    height: 40px;
    border: 1px solid #dddddd;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .divb {
    width: 96px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #a8abbe;
    background: #ffffff;
    border: 1px solid #dddddd;
    border-radius: 2px;
    cursor: pointer;
  }

  .divb:hover {
    width: 96px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    background: #ffffff;
    border-radius: 2px;
    cursor: pointer;
    border: 1px solid #ff4027;
    color: #ff4027;
  }

  .toLogin {
    display: flex;
    justify-content: center;
    padding-bottom: 40px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ff5e51;
    cursor: pointer;
  }

  .choice {
    height: auto;
    margin: auto;
    margin-top: 10px;
    display: flex;
    align-items: center;

    .choiceLeft {
      font-weight: bold;
      width: auto;
      height: 35px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .choiceLeftText {
        width: auto;
        height: 24px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333;
      }

      .class1 {
        color: #ff4027;
        cursor: pointer;
      }

      .choiceLefts {
        margin: auto;
        margin-top: 8px;
        width: 30px;
        height: 3px;
        background: linear-gradient(90deg, #ff4027 0%, #ff5400 100%);
        border-radius: 2px;
      }
    }

    .choices {
      width: 1px;
      height: 16px;
      background: #dddddd;
      margin-bottom: 7px;
    }
  }

  .colf2 {
    background: #f2f2f2;
  }

  .confirmBtn {
    padding: 20px 0;
  }

  .confirmBtnSecond {
    padding-bottom: 40px;
  }
}

.confirmPhone {
  display: flex;
  margin: 0 0 20px 0;
}

/deep/.el-input__inner {
  border: none !important;
  background: #f2f2f2 !important;
}

/deep/.el-form-item__content {
  display: flex;
  height: 40px;
}

/deep/.el-input__inner:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px #f2f2f2 inset !important;
  background-color: #f2f2f2 !important;
}
</style>
